module.exports = __webpack_public_path__ + "static/media/4_portrait.1c4a8320.jpg";